<template>

  <div :id="componentId" class="ui large modal invoice-modal">

    <div class="ui header">
      Visualização de Nota Fiscal
    </div>

    <div class="content modal-content-scrolling">

      <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

      <div v-if="!loading && invoice" class="animated fadeIn">

        <form class="ui form">
          <div class="fields">            
            <div class="three wide field">
              <label class="form-label">Filial</label>
              <span>{{ branchId + ' - ' + $branchName(invoice.branch) }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Número</label>
              <span>{{ number + ' / ' + series }}</span>
            </div>
            <div class="two wide field">
              <label class="form-label">Emissão</label>
              <span>{{ $formatDate(invoice.date) }}</span>
            </div>
            <div class="two wide field">
              <label class="form-label">Entrega</label>
              <span>{{ $formatDate(invoice.deliveryDate) }}</span>
            </div>
            <div class="four wide field">
              <label class="form-label">Valor Total</label>
              <span>R$ {{ $formatCurrency(invoice.total) }}</span>
            </div>
          </div>
          <div class="fields">
            <div class="ten wide field">
              <label class="form-label">Cliente</label>
              <span>{{ invoice.nameCustomer }}</span>
            </div>
            <div class="six wide field">
              <label class="form-label">Transportadora</label>
              <span>{{ invoice.carrier }}</span>
            </div>          
          </div>        
        </form>

        <div class="ui segment m-t-20">
          <table class="ui very basic celled tablet stackable table">
            <thead class="desktop-only">
              <tr>
                <th>Item</th>
                <th>Produto</th>
                <th>Quantidade</th>
                <th>Preço</th>
                <th>Valor Total</th>
                <th>Pedido</th>
                <th>Item Pedido</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in invoice.items">
                <td><strong class="mobile-only">Item: </strong>{{ item.item }}</td>
                <td><strong class="mobile-only">Produto: </strong>{{ item.description }}</td>
                <td><strong class="mobile-only">Quantidade: </strong>{{ $formatInteger(item.quantity) }}</td>
                <td><strong class="mobile-only">Preço: </strong>{{ $formatCurrency(item.price) }}</td>
                <td><strong class="mobile-only">Valor Total: </strong>{{ $formatCurrency(item.total) }}</td>
                <td><strong class="mobile-only">Pedido: </strong>{{ item.salesOrderId }}</td>            
                <td><strong class="mobile-only">Item Pedido: </strong>{{ item.orderItem }}</td>            
              </tr>                   
            </tbody>
          </table>
        </div>            

      </div>

    </div>

    <div class="actions">
      <button class="ui basic button" @click="hide()">
        <i class="reply icon"></i>
        Sair
      </button>      
    </div>

  </div>

</template>

<script>

  import InvoiceService from "@/services/invoice-service"

  export default {
    
    data() {
      return {
        componentId: "invoice-dialog",
        loading: false,
        invoice: null,
      }
    },

    props: ["id", "branchId", "number", "series"],

    watch: {

      "number" () {
        this.loadInvoice()
      },
    },

    created() {

      if (this.id)
        this.componentId = this.id
    },

    mounted() {

      $("#" + this.componentId).modal({ allowMultiple: true })
    },

    beforeDestroy() {
      $(".invoice-modal").remove()
    },

    methods: {

      show() {
        $("#" + this.componentId).modal("show")
      },

      hide() {
        $("#" + this.componentId).modal("hide")
      },

      async loadInvoice() {

        this.loading = true

        try {

          this.invoice = await InvoiceService.getById(this.branchId, this.number, this.series)
          
          this.loading = false
          
        } catch (error) {
          
          this.loading = false
          this.$errorHandler(error)
        }
      },
    },
  }

</script>

